// Auto-scroll collection carousel - 2 loops then stop
document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('.scroll-area.bleed.is-scrollable');
  if (!carousel) return;

  const cardWidth = carousel.querySelector('.collection-card')?.offsetWidth || 200;
  const totalWidth = carousel.scrollWidth;
  const maxScroll = totalWidth - carousel.clientWidth;
  let loops = 0;
  let scrollInterval;

  function autoScroll() {
    carousel.scrollBy({ left: 1, behavior: 'smooth' });

    if (carousel.scrollLeft >= maxScroll) {
      loops++;
      if (loops >= 2) {
        clearInterval(scrollInterval);
        return;
      }
      setTimeout(() => {
        carousel.scrollTo({ left: 0, behavior: 'smooth' });
      }, 500);
    }
  }

  // Pause on hover
  carousel.addEventListener('mouseenter', () => clearInterval(scrollInterval));
  carousel.addEventListener('mouseleave', () => {
    if (loops < 2) scrollInterval = setInterval(autoScroll, 16);
  });

  // Start after 1 second
  setTimeout(() => {
    scrollInterval = setInterval(autoScroll, 16);
  }, 1000);
});
